import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import icons from '@core/icons';
import light from '../themes/light';
import shortcutsStore from "@core/mixins/shortcutsStore";
Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdiSvg',
        values: icons,
    },
    theme: {
        options: {
            customProperties: true,
            variations: false,
        },
        themes: {
            light: {
                primary: _theme.primaryColor,
                secondary: _theme.secondaryColor,
            }
        }
    }
});
